import React from 'react';
import {segmentHebrewByRoot} from '../helpers/rootLetterMnemonics';

// Renders a Hebrew string, coloring the root (shoresh) letters so learners can
// spot the root pattern across conjugations. Root letters keep their vowels
// attached — only complete letter+mark clusters are wrapped in colored spans.
export const RootColoredText = ({text, rootLetters, className}) => {
  if (!text) return null;

  if (!rootLetters || rootLetters.length < 2) {
    return <span className={className}>{text}</span>;
  }

  const segments = segmentHebrewByRoot(text, rootLetters);

  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.color ? (
          <span key={i} className="conjugation-root-letter" style={{color: seg.color}}>
            {seg.text}
          </span>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </span>
  );
};
